// ============================================================
// Protected nav — arahkan guest ke login sebelum halaman auth
// ============================================================

export function getAuthToken() {
  try {
    return window.Alpine?.store('auth')?.token || localStorage.getItem('uspatih_token');
  } catch {
    return localStorage.getItem('uspatih_token');
  }
}

export function isLoggedIn() {
  const store = window.Alpine?.store('auth');
  if (store && typeof store.isLoggedIn === 'boolean') {
    return store.isLoggedIn;
  }

  return !!getAuthToken();
}

export function goToProtectedUrl(targetUrl, loginUrl = '/login') {
  if (isLoggedIn()) {
    window.location.href = targetUrl;
    return true;
  }

  window.location.href = `${loginUrl}?redirect=${encodeURIComponent(targetUrl)}`;
  return false;
}

export function initProtectedNavLinks(root = document) {
  root.querySelectorAll('[data-protected-nav]').forEach((el) => {
    if (el.dataset.protectedNavBound === '1') return;
    el.dataset.protectedNavBound = '1';

    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = el.getAttribute('data-target-url') || el.getAttribute('href') || '/';
      const login = el.getAttribute('data-login-url') || '/login';
      goToProtectedUrl(target, login);
    });
  });
}
